export const translations = {
  it: {
    nav: {
      gruppo: "GRUPPO",
      marchi: "MARCHI",
      fabbriche: "FABBRICHE",
      progetti: "PROGETTI",
      shop: "SHOP",
      certificazioni: "CERTIFICAZIONI",
      contatti: "CONTATTI",
    },
    share: {
      title: "Condividi questa pagina",
      description: "Scegli come condividere questa pagina",
      copy: "Copia",
      copied: "Copiato!",
      linkCopied: "Link copiato negli appunti",
      linkError: "Errore durante la copia del link",
      emailBody: "Guarda questa pagina",
      native: "Condividi",
    },
    gruppo: {
      chiSiamo: "Chi Siamo",
      valori: "I Valori delle Fabbriche",
      comeOperano: "Come operano le Fabbriche",
      mercati: "Mercati e Clientela",
    },
    marchi: {
      nostri: "I Nostri Marchi",
      difesa: "I Marchi della Difesa",
    },
    fabbriche: {
      cioccolateria: "Cioccolateria",
      biscottificio: "Biscottificio",
      distilleria: "Distilleria",
      laboratorio: "Laboratorio Farmaceutico",
      azienda: "Azienda Agricola",
    },
    progetti: {
      privateLabel: "Private Label",
      hotellerie: "Hotellerie",
      ristorazione: "Ristorazione",
      regalistica: "Regali Aziendali",
    },
    hero: {
      title: "Fabbriche Toscane",
      subtitle: "L'eccellenza artigianale toscana incontra l'innovazione moderna",
      description:
        "Produciamo prodotti alimentari di eccellenza in concessione e realizziamo soluzioni private label per il settore HORECA",
      cta: "Scopri di più",
    },
    footer: {
      azienda: "Azienda",
      gruppo: "Il Gruppo",
      fabbriche: "Le Fabbriche",
      marchi: "I Marchi",
      progetti: "Progetti",
      servizi: "Servizi",
      privateLabel: "Private Label",
      hotellerie: "Hotellerie",
      ristorazione: "Ristorazione",
      regalistica: "Regalistica Aziendale",
      contatti: "Contatti",
      email: "Email",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      legal: "Legale",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      termini: "Termini di Servizio",
      followUs: "Seguici",
      rights: "Tutti i diritti riservati.",
    },
    common: {
      readMore: "Scopri di più",
      contact: "Contattaci",
      learnMore: "Scopri di più",
    },
    pages: {
      index: {
        ourBrands: "I NOSTRI MARCHI",
        ourBrandsDesc: "Tradizione e innovazione si incontrano nei nostri marchi storici",
        defenseBrands: "I MARCHI DELLA DIFESA",
        defenseBrandsDesc: "Prodotti di eccellenza realizzati in licenza da Difesa Servizi",
        projectsTitle: "PROGETTI E SERVIZI",
        projectsDesc: "Soluzioni personalizzate per ogni esigenza di business",
      },
      gruppo: {
        title: "IL GRUPPO FABBRICHE TOSCANE",
        subtitle:
          "Siamo esploratori enogastronomici, antropologi, e facciamo tutto questo amando la socialità e le persone.",
        whoWeAre: "Chi Siamo",
        whoWeAreText1:
          "Nato nella primavera del 2025, Fabbriche Toscane srl è un gruppo giovane con un solido know-how che raccoglie l'eredità di una storica realtà locale, custode della nobile arte della cioccolateria e della distilleria. La missione aziendale è scoprire e valorizzare le eccellenze nascoste dell'agroalimentare e della manifattura toscana, operando secondo criteri di etica e sostenibilità, sia ambientale che finanziaria.",
        whoWeAreText2:
          "L'obiettivo principale è l'integrazione di logiche gestionali moderne e innovative all'interno delle piccole imprese, armonizzandole con gli antichi saperi del territorio. Per questo, l'attività si orienta verso la produzione di eccellenze certificate, nate dal connubio tra materie prime selezionate e tecniche avanzate.",
        whoWeAreText3:
          "Questo approccio si riflette in un impegno costante verso l'ottimizzazione dei processi e la cura delle relazioni umane lungo tutta la filiera. L'azienda si impegna a costruire rapporti aperti e trasparenti con dipendenti, fornitori e clienti, nella ferma convinzione che la qualità del prodotto finale sia indissolubilmente legata al valore delle persone e alla solidità dei legami che ne sostengono la crescita.",
        valuesTitle: "I Valori delle Fabbriche",
        value1Title: "Saperi Antichi",
        value1Text:
          "Fabbriche Toscane è il custode e il catalizzatore delle eccellenze artigianali toscane, riportandole alla luce per proiettarle nel futuro.",
        value2Title: "Qualità e Sostenibilità",
        value2Text:
          "Ogni azione è guidata dalla ricerca della massima qualità, intrinsecamente legata a un modello di sostenibilità etica, ambientale e finanziaria, abilitato da efficienza ed economie di scala.",
        value3Title: "Umanesimo Toscano",
        value3Text:
          "Esporta l'anima \"fattiva\" della regione nel mondo. Rappresenta un territorio che ha creato la modernità e l'umanesimo, perfetta sintesi di arte, bellezza e spirito imprenditoriale.",
        value4Title: "Innovazione",
        value4Text:
          "Un laboratorio vivo dove i saperi tramandati si incontrano con le più avanzate competenze tecnologiche, finanziarie e agroalimentari.",
        howWeOperate: "Come operano le Fabbriche",
        operate1:
          "Siamo un <strong>Polo di eccellenza</strong> artigiana che raggruppa i migliori produttori dell'agroalimentare e del benessere del territorio toscano",
        operate2: "Operiamo con diverse",
        operate2Link: "Fabbriche",
        operate2Continue: "e impianti produttivi che sviluppano la nostra vasta offerta di prodotti.",
        operate3: "Commercializziamo i nostri prodotti attraverso una serie di",
        operate3Link1: "Marchi",
        operate3Mid: ", sia storici che di nuova concezione, oltre che per terze parti in",
        operate3Link2: "Private Label",
        operate4:
          "<strong>Accentriamo e ottimizziamo</strong> tutti i processi operativi, gestionali, amministrativi, logistici e commerciali di ciascuna delle Fabbriche, sviluppando sinergie e lasciando i mastri artigiani liberi di dedicarsi alla produzione di eccellenza.",
        marketsTitle: "Mercati e Clientela",
        marketsText:
          "Operiamo nei segmenti B2B (HoReCa premium, GDO di fascia alta, corporate gifting, farmacie e parafarmacie) e B2C (gourmet & food lovers, wellness & beauty), con un posizionamento orientato all'export e alla distribuzione multicanale.",
        imageAlt:
          "Alambicco in rame G. Frilli nella distilleria — simbolo dell'eccellenza manifatturiera toscana di Fabbriche Toscane",
      },
      marchi: {
        title: "I MARCHI DI FABBRICHE TOSCANE",
        subtitle:
          "Fabbriche Toscane distribuisce i suo prodotti attraverso marchi di proprietà, produce per marchi terzi e detiene la licenza dei marchi in concessione da Difesa Servizi.",
        ourBrands: "I NOSTRI MARCHI",
        ourBrandsDesc: "Le eccellenze prodotte dalle nostre Fabbriche",
        ourBrandsText:
          "Realizzano e distribuiamo una vasta gamma di prodotti gastronomici e del benessere direttamente con i marchi di nostra proprietà. Questi sono sia marchi storici della tradizione del nostro territorio, che abbiamo recuperato e rilanciato, sia nuovi marchi che pur rispettando la nostra storia, la ripropongono con un tocco innovativo. Quello che però accomuna ogni nostro marchio è l'altissima qualità delle materie prime e l'amore che ogni nostro artigiano infonde nelle sue opere.",
        defenseBrands: "I MARCHI DELLA DIFESA",
        defenseBrandsDesc: "Prodotti realizzati per la Difesa italiana",
        defenseBrandsText:
          "Fabbriche Toscane detiene la licenza dei marchi in concessione da Difesa Servizi, e per essa cura la realizzazione dei suoi storici prodotti, rispettandone il blasone e garantendo la qualità e la sicurezza che li hanno resi iconici.",
      },
      progetti: {
        title: "PROGETTI IN PRIVATE LABEL E SERVIZI",
        subtitle: "Soluzioni personalizzate e integrate per soddisfare ogni esigenza dei nostri partner",
        privateLabel: "Private Label",
        privateLabelDesc:
          "Gestiamo la produzione per conto terzi, offrendo soluzioni su misura dall'ideazione del prodotto, al design del packaging fino alla produzione e logistica.",
        hotellerie: "Hotellerie",
        hotellerieDesc:
          "Forniamo servizi per l'hotellerie e l'hospitality creando proposte complete per le clientele più raffinate che comprendono prodotti enogastronomici e del benessere sia in private label che con i nostri marchi d'elite.",
        ristorazione: "Ristorazione",
        ristorazioneDesc:
          "I nostri prodotti di eccellenza sono ideali per essere integrati nei menù dei ristoranti e dei locali di alta gamma.",
        regalistica: "Regali Aziendali",
        regaliscaDesc:
          "Realizziamo soluzioni su misura per confezioni regalo, ideali per festività ed eventi speciali, grazie alla vasta selezione di prodotti di alta qualità.",
      },
      products: {
        title: "I Nostri Prodotti di Eccellenza",
        description:
          "Oltre 100 prodotti, sviluppati dalla nostre Fabbriche con ingredienti selezionati e processi artigianali che garantiscono qualità superiore e sapori autentici.",
        chocolate: "Cioccolata",
        spreads: "Spalmabili",
        biscuits: "Biscotti",
        spirits: "Distillati",
        bitters: "Amari",
        creams: "Creme",
        shopCta: "Visita Lo Shop",
        imageAlt: "Prodotti alimentari di eccellenza dell'Emporio delle Fabbriche",
      },
      services: {
        title: "I Nostri Servizi",
        subtitle: "Due soluzioni integrate per soddisfare ogni esigenza del mercato alimentare di eccellenza",
        concessionTitle: "Produzione in Concessione",
        concessionDesc:
          "Gestiamo la produzione di prodotti alimentari di eccellenza per conto terzi, mantenendo gli standard più elevati del mercato.",
        privateLabelTitle: "Private Label",
        privateLabelDesc:
          "Creiamo soluzioni private label personalizzate per hotel, ristoranti e catering, adattando i prodotti alle esigenze specifiche.",
        feature1: "Facility Certificata",
        feature2: "Processi Controllati",
        feature3: "Scalabilità",
        feature4: "Compliance Totale",
        feature5: "Personalizzazione",
        feature6: "Volumi Flessibili",
        feature7: "Supporto Tecnico",
        feature8: "Logistica Dedicata",
        learnMore: "Scopri di più",
      },
    },
  },
  en: {
    nav: {
      gruppo: "GROUP",
      marchi: "BRANDS",
      fabbriche: "FACTORIES",
      progetti: "PROJECTS",
      shop: "SHOP",
      certificazioni: "CERTIFICATIONS",
      contatti: "CONTACTS",
    },
    share: {
      title: "Share this page",
      description: "Choose how to share this page",
      copy: "Copy",
      copied: "Copied!",
      linkCopied: "Link copied to clipboard",
      linkError: "Error copying link",
      emailBody: "Check out this page",
      native: "Share",
    },
    gruppo: {
      chiSiamo: "About Us",
      valori: "Factory Values",
      comeOperano: "How Factories Operate",
      mercati: "Markets and Customers",
    },
    marchi: {
      nostri: "Our Brands",
      difesa: "Defense Brands",
    },
    fabbriche: {
      cioccolateria: "Chocolate Factory",
      biscottificio: "Biscuit Factory",
      distilleria: "Distillery",
      laboratorio: "Pharmaceutical Laboratory",
      azienda: "Farm",
    },
    progetti: {
      privateLabel: "Private Label",
      hotellerie: "Hospitality",
      ristorazione: "Restaurant Industry",
      regalistica: "Corporate Gifts",
    },
    hero: {
      title: "Fabbriche Toscane",
      subtitle: "Tuscan artisan excellence meets modern innovation",
      description:
        "We produce excellence food products under concession and create private label solutions for the HORECA sector",
      cta: "Discover more",
    },
    footer: {
      azienda: "Company",
      gruppo: "The Group",
      fabbriche: "The Factories",
      marchi: "The Brands",
      progetti: "Projects",
      servizi: "Services",
      privateLabel: "Private Label",
      hotellerie: "Hospitality",
      ristorazione: "Restaurant Industry",
      regalistica: "Corporate Gifts",
      contatti: "Contacts",
      email: "Email",
      telefono: "Phone",
      indirizzo: "Address",
      legal: "Legal",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      termini: "Terms of Service",
      followUs: "Follow Us",
      rights: "All rights reserved.",
    },
    common: {
      readMore: "Read more",
      contact: "Contact us",
      learnMore: "Learn more",
    },
    pages: {
      index: {
        ourBrands: "OUR BRANDS",
        ourBrandsDesc: "Tradition and innovation meet in our historic brands",
        defenseBrands: "DEFENSE BRANDS",
        defenseBrandsDesc: "Excellence products for the Italian Armed Forces licensed by Difesa Servizi",
        projectsTitle: "PROJECTS AND SERVICES",
        projectsDesc: "Customized solutions for every business need",
      },
      gruppo: {
        title: "THE FABBRICHE TOSCANE GROUP",
        subtitle:
          "We are food and wine explorers, anthropologists, and we do all this by loving sociability and people.",
        whoWeAre: "About Us",
        whoWeAreText1:
          "Born in the spring of 2025, Fabbriche Toscane srl is a young group with solid know-how that inherits the legacy of a historic local company, guardian of the noble art of chocolate making and distilling. The corporate mission is to discover and enhance the hidden excellences of Tuscan agri-food and manufacturing, operating according to criteria of ethics and sustainability, both environmental and financial.",
        whoWeAreText2:
          "The main objective is the integration of modern and innovative management logic within small businesses, harmonizing them with the ancient knowledge of the territory. For this reason, the activity is oriented towards the production of certified excellences, born from the combination of selected raw materials and advanced techniques.",
        whoWeAreText3:
          "This approach is reflected in a constant commitment to process optimization and the care of human relationships throughout the entire supply chain. The company is committed to building open and transparent relationships with employees, suppliers and customers, in the firm belief that the quality of the final product is inextricably linked to the value of the people and the strength of the bonds that support its growth.",
        valuesTitle: "Factory Values",
        value1Title: "Ancient Knowledge",
        value1Text:
          "Fabbriche Toscane is the guardian and catalyst of Tuscan artisan excellence, bringing it to light to project it into the future.",
        value2Title: "Quality and Sustainability",
        value2Text:
          "Every action is guided by the pursuit of maximum quality, intrinsically linked to a model of ethical, environmental and financial sustainability, enabled by efficiency and economies of scale.",
        value3Title: "Tuscan Humanism",
        value3Text:
          'Exports the "proactive" soul of the region to the world. Represents a territory that created modernity and humanism, a perfect synthesis of art, beauty and entrepreneurial spirit.',
        value4Title: "Innovation",
        value4Text:
          "A living laboratory where handed-down knowledge meets the most advanced technological, financial and agri-food skills.",
        howWeOperate: "How Factories Operate",
        operate1:
          "We are a <strong>Center of excellence</strong> in craftsmanship that brings together the best agri-food and wellness producers in the Tuscan territory",
        operate2: "We operate with various",
        operate2Link: "Factories",
        operate2Continue: "and production facilities that develop our vast product offering.",
        operate3: "We market our products through a series of",
        operate3Link1: "Brands",
        operate3Mid: ", both historic and newly conceived, as well as for third parties in",
        operate3Link2: "Private Label",
        operate4:
          "<strong>We centralize and optimize</strong> all operational, management, administrative, logistics and commercial processes of each Factory, developing synergies and leaving master craftsmen free to dedicate themselves to production of excellence.",
        marketsTitle: "Markets and Customers",
        marketsText:
          "We operate in B2B segments (premium HoReCa, high-end large-scale retail, corporate gifting, pharmacies and parapharmacies) and B2C (gourmet & food lovers, wellness & beauty), with a positioning oriented towards export and multichannel distribution.",
        imageAlt:
          "G. Frilli copper still in the distillery — symbol of Tuscan manufacturing excellence of Fabbriche Toscane",
      },
      marchi: {
        title: "FABBRICHE TOSCANE BRANDS",
        subtitle:
          "Fabbriche Toscane distributes its products through proprietary brands, produces for third-party brands and holds the license for brands under concession from Difesa Servizi.",
        ourBrands: "OUR BRANDS",
        ourBrandsDesc: "Excellence produced by our Factories",
        ourBrandsText:
          "We create and distribute a wide range of gastronomic and wellness products directly with our proprietary brands. These are both historic brands from our territorial tradition, which we have recovered and relaunched, and new brands that while respecting our history, reinterpret it with an innovative touch. What unites all our brands, however, is the very high quality of raw materials and the love that each of our artisans infuses into their works.",
        defenseBrands: "DEFENSE BRANDS",
        defenseBrandsDesc: "Products made for the Italian Defense",
        defenseBrandsText:
          "Fabbriche Toscane holds the license for brands under concession from Difesa Servizi, and for it takes care of the production of its historic products, respecting its coat of arms and guaranteeing the quality and safety that have made them iconic.",
      },
      progetti: {
        title: "PRIVATE LABEL PROJECTS AND SERVICES",
        subtitle: "Customized and integrated solutions to meet every need of our partners",
        privateLabel: "Private Label",
        privateLabelDesc:
          "We manage production for third parties, offering tailor-made solutions from product ideation, to packaging design to production and logistics.",
        hotellerie: "Hospitality",
        hotellerieDesc:
          "We provide services for the hotel and hospitality industry by creating complete proposals for the most refined clientele that include gastronomic and wellness products both in private label and with our elite brands.",
        ristorazione: "Restaurant Industry",
        ristorazioneDesc:
          "Our products of excellence are ideal to be integrated into the menus of restaurants and high-end venues.",
        regalistica: "Corporate Gifts",
        regaliscaDesc:
          "We create tailor-made solutions for gift packages, ideal for holidays and special events, thanks to our vast selection of high quality products.",
      },
      products: {
        title: "Emporio delle Fabbriche: Our Products of Excellence",
        description:
          "Our Emporio includes over 100 products, developed by our Factories with selected ingredients and artisan processes that guarantee superior quality and authentic flavors.",
        chocolate: "Chocolate",
        spreads: "Spreads",
        biscuits: "Biscuits",
        spirits: "Spirits",
        bitters: "Bitters",
        creams: "Creams",
        shopCta: "Visit The Shop",
        imageAlt: "Excellent food products from Emporio delle Fabbriche",
      },
      services: {
        title: "Our Services",
        subtitle: "Two integrated solutions to meet every need of the food excellence market",
        concessionTitle: "Concession Production",
        concessionDesc:
          "We manage the production of excellent food products on behalf of third parties, maintaining the highest standards on the market.",
        privateLabelTitle: "Private Label",
        privateLabelDesc:
          "We create customized private label solutions for hotels, restaurants and catering, adapting products to specific needs.",
        feature1: "Certified Facility",
        feature2: "Controlled Processes",
        feature3: "Scalability",
        feature4: "Total Compliance",
        feature5: "Customization",
        feature6: "Flexible Volumes",
        feature7: "Technical Support",
        feature8: "Dedicated Logistics",
        learnMore: "Learn more",
      },
    },
  },
};
